module.exports = __webpack_public_path__ + "media/react/components/Notifications/Notification/assets/trash_hat-a1c81f65ae16fbfce4a9322c36ac2f63.svg";